__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@kne/ai-interview";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@kne/global-context", "1.3.2", () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(628)]).then(() => (() => (__webpack_require__(628))))));
			register("@kne/local-storage", "0.1.1", () => (__webpack_require__.e(4416).then(() => (() => (__webpack_require__(4416))))));
			register("@kne/react-fetch", "1.5.5", () => (Promise.all([__webpack_require__.e(8295), __webpack_require__.e(7630), __webpack_require__.e(3201), __webpack_require__.e(3884)]).then(() => (() => (__webpack_require__(3201))))));
			register("@kne/react-intl", "0.1.9", () => (Promise.all([__webpack_require__.e(7308), __webpack_require__.e(3884), __webpack_require__.e(3694)]).then(() => (() => (__webpack_require__(7308))))));
			register("@kne/remote-loader", "1.3.3", () => (Promise.all([__webpack_require__.e(8295), __webpack_require__.e(7630), __webpack_require__.e(8601), __webpack_require__.e(3884), __webpack_require__.e(6418)]).then(() => (() => (__webpack_require__(8601))))));
			register("@kne/use-ref-callback", "0.1.2", () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(1400)]).then(() => (() => (__webpack_require__(1400))))));
			register("agora-rtc-sdk-ng", "4.24.2", () => (__webpack_require__.e(1635).then(() => (() => (__webpack_require__(1635))))));
			register("antd", "5.29.3", () => (Promise.all([__webpack_require__.e(1348), __webpack_require__.e(3884), __webpack_require__.e(486), __webpack_require__.e(7469)]).then(() => (() => (__webpack_require__(1348))))));
			register("axios", "1.13.2", () => (Promise.all([__webpack_require__.e(2084), __webpack_require__.e(9379)]).then(() => (() => (__webpack_require__(2084))))));
			register("dayjs", "1.11.19", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(446))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(7950), __webpack_require__.e(3884)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.30.2", () => (Promise.all([__webpack_require__.e(3245), __webpack_require__.e(3884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(5043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};